import { OrderTypeCustomFieldDataType } from '../../@types/orderTypes';

export const isValidCustomFieldValue = (
  dataType: OrderTypeCustomFieldDataType,
  enumValues: string[],
  value: string
): boolean => {
  switch (dataType) {
    case OrderTypeCustomFieldDataType.String:
      return true;
    case OrderTypeCustomFieldDataType.Int:
      return /^-?\d+$/.test(value);
    case OrderTypeCustomFieldDataType.Decimal:
      return /^-?\d+(\.\d+)?$/.test(value);
    case OrderTypeCustomFieldDataType.Bool:
      return /^(true|false)$/i.test(value);
    case OrderTypeCustomFieldDataType.Date:
      return /^\d{4}-\d{2}-\d{2}$/.test(value) && !Number.isNaN(Date.parse(value));
    case OrderTypeCustomFieldDataType.Enum:
      return enumValues.includes(value);
    default:
      return false;
  }
};
